import React from 'react';
import { styled } from '../../themeCustomink';
var TrimStyles = styled('div', {
    name: 'pigment-colorswatch-trim',
})({
    borderBottomRightRadius: '4px',
    borderTopRightRadius: '4px',
    position: 'absolute',
    bottom: 0,
    right: 0,
    top: 0,
    width: '33%',
    pointerEvents: 'none',
});
export var TrimSwatch = function (_a) {
    var trimRgb = _a.trimRgb;
    return (React.createElement(TrimStyles, { className: "pigment-colorswatch-trim", style: {
            backgroundColor: trimRgb,
        } }));
};
//# sourceMappingURL=TrimSwatch.js.map